import { ActionIcon, Badge, Box, Group, Stack, Text } from '@mantine/core';
import {
    faThumbsDown as faLightThumbsDown,
    faThumbsUp as faLightThumbsUp,
} from '@fortawesome/pro-light-svg-icons';
import { faThumbsDown, faThumbsUp } from '@fortawesome/pro-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const UserRatingCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const positive =
        rowData.assessments?.user && rowData.assessments.user === true;
    const negative =
        rowData.assessments?.user && rowData.assessments.user === false;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Group gap={'xs'}>
                <ActionIcon variant='subtle'>
                    <FontAwesomeIcon
                        icon={positive ? faThumbsUp : faLightThumbsUp}
                    />
                </ActionIcon>
                <ActionIcon variant='subtle'>
                    <FontAwesomeIcon
                        icon={negative ? faThumbsDown : faLightThumbsDown}
                    />
                </ActionIcon>
            </Group>
        </Box>
    );
};

const UserRatingColumn = () => ({
    accessorKey: 'rating',
    header: 'User Rating',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <UserRatingCell cell={cell} />,
});
export default UserRatingColumn;
